import EntityChallengeBulkMediaDelete from './EntityChallengeBulkMediaDelete';

export default EntityChallengeBulkMediaDelete;
